define("shared/components/shared/social-identity/item", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    ...attributes
    class="cSS--set__item {{if this.selectable 'cSS--set__item--dashed'}}"
    data-test-id="social set profile"
    {{on "click" this.toggleEditing}}
  >
    <Shared::ProfileAvatar
      @showOutline={{true}}
      @showPlatform={{true}}
      @size="medium"
      @socialProfile={{@socialProfile}}
      class="cSS--user {{if this.lockProfile 'is--locked'}}"
    />
  
    {{#unless this.selectable}}
      <EmberTooltip @event="hover" @popperContainer="body" @tooltipClass={{if @customClass @customClass "tooltip"}}>
        <span data-test-id="hover displayNickname">{{@socialProfile.displayNickname}}</span>
      </EmberTooltip>
    {{/unless}}
  </div>
  */
  {
    "id": "yuG5IVmP",
    "block": "[[[11,0],[17,1],[16,0,[29,[\"cSS--set__item \",[52,[30,0,[\"selectable\"]],\"cSS--set__item--dashed\"]]]],[24,\"data-test-id\",\"social set profile\"],[4,[38,1],[\"click\",[30,0,[\"toggleEditing\"]]],null],[12],[1,\"\\n  \"],[8,[39,2],[[16,0,[29,[\"cSS--user \",[52,[30,0,[\"lockProfile\"]],\"is--locked\"]]]]],[[\"@showOutline\",\"@showPlatform\",\"@size\",\"@socialProfile\"],[true,true,\"medium\",[30,2]]],null],[1,\"\\n\\n\"],[41,[51,[30,0,[\"selectable\"]]],[[[1,\"    \"],[8,[39,4],null,[[\"@event\",\"@popperContainer\",\"@tooltipClass\"],[\"hover\",\"body\",[52,[30,3],[30,3],\"tooltip\"]]],[[\"default\"],[[[[1,\"\\n      \"],[10,1],[14,\"data-test-id\",\"hover displayNickname\"],[12],[1,[30,2,[\"displayNickname\"]]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"&attrs\",\"@socialProfile\",\"@customClass\"],false,[\"if\",\"on\",\"shared/profile-avatar\",\"unless\",\"ember-tooltip\"]]",
    "moduleName": "shared/components/shared/social-identity/item.hbs",
    "isStrictMode": false
  });

  /**
   * @class Item
   *
   * @extends Component
   *
   * This component is mostly a wrapper for the Shared::ProfileAvatar component but adds
   * some wrapping elements for the functionality needed for social identities(sets).
   *
   * Required Arguments:
   * - socialProfile (SocialProfile|Object) A Social Profile object.
   *
   * Optional Arguments:
   * - socialIdentity (SocialIdentity|Object) An identity that is used to display the relevant profiles.
   * - lockProfile (Boolean) Toggles whether to disable selecting the profile (and adds relevant CSS)
   * - selectable (Boolean) Toggles whether to show "targetable" area around the profile. Used for /trade route.
   * Examples:
  
   * Inline Usage with all options:
   * ```
   * <Shared::SocialIdentity::Item
   *   @socialProfile={{socialProfile.profile}}
   *   @lockProfile={{false}}
   *   @selectable={{true}}
   * />
   * ```
   *
   */
  let ItemComponent = _exports.default = (_class = class ItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "isEditing", _descriptor, this);
    }
    toggleEditing() {
      this.isEditing = !this.isEditing;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditing", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleEditing", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEditing"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ItemComponent);
});